import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PautasReunioesComponent } from '../pautas-reunioes/pautas-reunioes.component';
import { OperacoesConsultaParticipanteComponent } from '../operacoes-consulta-participante/operacoes-consulta-participante.component';
import { EnviarEmailComponent } from '../enviar-email/enviar-email.component';
import { PainelControleGerencialComponent } from '../painel-controle-gerencial/painel-controle-gerencial.component';
import { PainelAvaliacaoRiscoComponent } from '../painel-avaliacao-risco/painel-avaliacao-risco.component';


const administrativoRoutes = [
    { path: 'pautasReuniao/comiteInvGestao', component: PautasReunioesComponent },
    { path: 'pautasReuniao/diretoria', component: PautasReunioesComponent },
    { path: 'pautasReuniao/concelhoFiscal', component: PautasReunioesComponent },
    { path: 'pautasReuniao/conselhoDeliberativo', component: PautasReunioesComponent },
    { path: 'operacoesConsultaParticipante', component: OperacoesConsultaParticipanteComponent },
    { path: 'enviarEmails', component: EnviarEmailComponent },
    { path: 'painelControleGerencial', component: PainelControleGerencialComponent },
    { path: 'painelAvaliacaoRisco', component: PainelAvaliacaoRiscoComponent }

];

@NgModule({
    imports: [RouterModule.forChild(administrativoRoutes)],
    exports: [RouterModule]
})
export class AdministrativoRouterngModule {


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/router/administrativo.router.ts